/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActorActivityRecordActorUserId } from './ActorActivityRecordActorUserId';
import {
    ActorActivityRecordActorUserIdFromJSON,
    ActorActivityRecordActorUserIdFromJSONTyped,
    ActorActivityRecordActorUserIdToJSON,
    ActorActivityRecordActorUserIdToJSONTyped,
} from './ActorActivityRecordActorUserId';

/**
 * 
 * @export
 * @interface ContractorTarget
 */
export interface ContractorTarget {
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ContractorTarget
     */
    id: ActorActivityRecordActorUserId | null;
    /**
     * 
     * @type {ActorActivityRecordActorUserId}
     * @memberof ContractorTarget
     */
    userId: ActorActivityRecordActorUserId | null;
}

/**
 * Check if a given object implements the ContractorTarget interface.
 */
export function instanceOfContractorTarget(value: object): value is ContractorTarget {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    return true;
}

export function ContractorTargetFromJSON(json: any): ContractorTarget {
    return ContractorTargetFromJSONTyped(json, false);
}

export function ContractorTargetFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractorTarget {
    if (json == null) {
        return json;
    }
    return {
        
        'id': ActorActivityRecordActorUserIdFromJSON(json['id']),
        'userId': ActorActivityRecordActorUserIdFromJSON(json['userId']),
    };
}

export function ContractorTargetToJSON(json: any): ContractorTarget {
    return ContractorTargetToJSONTyped(json, false);
}

export function ContractorTargetToJSONTyped(value?: ContractorTarget | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': ActorActivityRecordActorUserIdToJSON(value['id']),
        'userId': ActorActivityRecordActorUserIdToJSON(value['userId']),
    };
}

